import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { LanguageForm, LanguageFormFields,LanguageFormProps } from './LanguageForm';
import { LocaleForm, LocaleFormFields,LocaleFormProps } from './LocaleForm';
import { TimeZoneForm, TimeZoneFormFields, TimeZoneFormProps } from './TimeZoneForm';

export interface LanguageAndRegionSettingsProps {
  //data
  languageInitialValues: LanguageFormFields;
  localeInitialValues: LocaleFormFields;
  timeZoneInitialValues: TimeZoneFormFields;
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isServerUserSubplace?: boolean;
}

export function LanguageAndRegionSettings({languageInitialValues, localeInitialValues, timeZoneInitialValues, ...passThroughProps}: LanguageAndRegionSettingsProps) {
  const languageProps: LanguageFormProps = {
    initialValues: languageInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const localeProps: LocaleFormProps = {
    initialValues: localeInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const timeZoneProps: TimeZoneFormProps = {
    initialValues: timeZoneInitialValues,
    serverUser: passThroughProps.serverUser
  };
  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_LanguageAndRegion_Header()}</h2>
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <LanguageForm {...languageProps}/>
            <LocaleForm {...localeProps}/>
          </td>
        </tr>
        {!passThroughProps.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        {!passThroughProps.isServerUserSubplace &&
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <TimeZoneForm {...timeZoneProps} />
          </td>
        </tr>}
      </tbody>
    </table>
    </>
  );
}